module.exports = __webpack_public_path__ + "img/bk_06.16de86c7.png";